export default __webpack_public_path__ + "static/media/crusharmor2.6b06c2ac.png";